const Plans = () => import('./views/PlansView');
const CheckList = () => import('./views/CheckListView');

const routes = [
  {
    path: '/plan',
    name: 'plans',
    component: Plans
  },
  {
    path: '/plan/:moduleOrder',
    name: 'planDetail',
    component: Plans
  },
  {
    path: '/checkList',
    name: 'checkList',
    component: CheckList
  },
  {
    path: '/checkList/:checkListId',
    name: 'checkListId',
    component: CheckList
  },
];

export default router => {
  routes.forEach(element => {
    router.addRoute('main', element);
  });
};
